import React, { useState, useCallback, useEffect } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { useScreenSize } from '../../../../utils/media-query';
import { FormDate, FormImag, FormRegx, FormSelc, FormText } from '../../../script/components/form/form-item';
import { PopupPass } from '../../../script/components/popup/popup';
import { PanelToolbar } from '../../../script/components/detail-panel/detail-panel-toolbar/PanelToolbar';
import { Button, LoadPanel, ScrollView } from 'devextreme-react';
import Form, { GroupItem } from 'devextreme-react/cjs/form';
import { ImagItem } from './UserInfo-profile-item';
import { fwUtil } from '../../../script/util';
import { set } from '../../../../api/set';
import DefaultUser from '../../../assets/user-default.png';
import './profile.scss';

const defaultData = {
    user_idno: '',
    tota_name: '',
    user_name: '',
    user_enam: '',
    tele_numb: '',
    cell_numb: '',
    faxs_numb: '',
    posi_code: '',
    posi_name: '',
    dept_code: '',
    dept_name: '',
    mail_idno: '',
    regi_date: fwUtil.date.getsText.date(),
    resi_date: null,
    pict_imag: null,
    sign_imag: null,
    curr_pass: '',
    pass_word: '',
    conf_pass: '',
};

const targetApi = 'privat/mes/sys/info/registration/target';
const updateApi = 'privat/mes/sys/info/registration/update';

const getTotalName = (name, enam) => {
    const kName = name ? `${name} ` : '';
    const eName = enam ? `/ ${enam}` : '';

    return `${kName}${eName}`;
};

const setUser = set.mes.sys;

export default function UserProfilePage() {
    const { user } = useAuth();
    const { isXSmall, isSmall, isMedium } = useScreenSize();
    // 페이지 상태값
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    // 데이터
    const [data, setData] = useState(defaultData);
    const dataUpdate = useCallback((e) => setData(e), [setData]);
    // 부서, 직위 리스트
    const [deptList, setDeptList] = useState([]);
    const [posiList, setPosiList] = useState([]);
    const deptChange = useCallback((e) => setDeptList(e), []);
    const posiChange = useCallback((e) => setPosiList(e), []);
    // 비밀번호 변경
    const [passwordPopupVisible, setPasswordPopupVisibile] = useState(false);
    const passwordPopupHide = useCallback(() => setPasswordPopupVisibile(false), []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [deptResult, posiResult] = await Promise.all([setUser.dept(), setUser.posi()]);
                deptChange(deptResult);
                posiChange(posiResult);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [deptChange, posiChange]);

    // 사용자 정보 받아오기
    const handleSearch = useCallback(async () => {
        if (!user) {
            fwUtil.aler.toast.s1Erro();
        } else {
            setLoading(true);
            const sendData = { userIdno: user.userIdno };
            const res = await fwUtil.apis.search(targetApi, sendData) || [];
            const resData = {
                user_idno: res.user_idno || '',
                tota_name: getTotalName(res.user_name, res.user_enam),
                user_name: res.user_name || '',
                user_enam: res.user_enam || '',
                tele_numb: res.tele_numb || '',
                cell_numb: res.cell_numb || '',
                faxs_numb: res.faxs_numb || '',
                posi_code: res.posi_code || '',
                posi_name: res.posi_name || '',
                dept_code: res.dept_code || '',
                dept_name: res.dept_name || '',
                mail_idno: res.mail_idno || '',
                regi_date: res.regi_date || fwUtil.date.getsText.date(),
                resi_date: res.resi_date || null,
                pict_imag: res.pict_imag || null,
                sign_imag: res.sign_imag || null,
            };

            dataUpdate(resData);
            setLoading(false);
        }
    }, [dataUpdate, setLoading, user]);

    useEffect(() => {
        handleSearch();
    }, [handleSearch]);

    // 수정 상태 전환
    const toggleEditHandler = useCallback(() => {
        setIsEditing(!isEditing);
    }, [isEditing]);

    // 수정
    const updateField = (field) => (value) => {
        if (!data) return;

        if (field === 'dept_name') {
            const selectedDept = deptList.find(list => list.dept_name === value);
            if (selectedDept) {
                dataUpdate({ ...data, [field]: value, dept_code: selectedDept.dept_code });
            };
            return;
        };

        if (field === 'posi_name') {
            const selectedPosi = posiList.find(list => list.posi_name === value);
            if (selectedPosi) {
                dataUpdate({ ...data, [field]: value, posi_code: selectedPosi.posi_code });
            };
            return;
        };

        dataUpdate({ ...data, [field]: value });
    };

    // 제출
    const onSubmit = useCallback(async () => {
        setLoading(true);
        const postData = new FormData();

        postData.append('userIdno', data.user_idno || '');
        postData.append('userName', data.user_name || '');
        postData.append('userEnam', data.user_enam || '');
        postData.append('teleNumb', data.tele_numb || '');
        postData.append('cellNumb', data.cell_numb || '');
        postData.append('faxsNumb', data.faxs_numb || '');
        postData.append('posiCode', data.posi_code || '');
        postData.append('posiName', data.posi_name || '');
        postData.append('deptCode', data.dept_code || '');
        postData.append('deptName', data.dept_name || '');
        postData.append('mailIdno', data.mail_idno || '');
        postData.append('regiDate', data.regi_date || null);
        postData.append('resiDate', data.resi_date || null);
        postData.append('pictImag', data.pict_imag || null);
        postData.append('signImag', data.sign_imag || null);

        await fwUtil.apis.submit(updateApi, postData, handleSearch);
        setLoading(false);
    }, [data, handleSearch, setLoading]);

    const passPopupOnShowing = useCallback(() => {
        dataUpdate({
            ...data,
            curr_pass: '',
            pass_word: '',
            conf_pass: ''
        });
    }, [data, dataUpdate]);

    return (
        <>
            <PopupPass
                width={isXSmall ? '100%' : 450}
                data={data}
                updateField={updateField}
                visible={passwordPopupVisible}
                showing={passPopupOnShowing}
                hiding={passwordPopupHide}
            />
            <div id='fw-profile-container' className='fw-flex-box col'>
                <div className='fw-profile-header'>
                    <span className='fw-profile-title'>사용자 정보</span>
                </div>
                <div className='fw-profile-body'>
                    <ScrollView>
                        <div className='fw-user-row fw-flex-box row circle'>
                            {ImagItem({ value: fwUtil.conv.to.buffToBlob(data.pict_imag), onValueChange: updateField('pict_imag'), readOnly: !isEditing, size: 130, defaultValue: DefaultUser })}
                            <div className='fw-user-row-detail'>
                                <div className='fw-user-detail-item fw-flex-box col'>
                                    <div className='fw-user-name'>{user.userName || "-"}</div>
                                    <div className='fw-user-id'>ID: {user.userIdno || "확인불가"}</div>
                                </div>
                                <div className='fw-user-pass-wrapper fw-user-detail-item'>
                                    <Button
                                        icon={'lock'}
                                        text={'비밀번호 변경'}
                                        onClick={() => setPasswordPopupVisibile(true)}
                                    />
                                </div>
                            </div>
                        </div>
                        <Form>
                            <GroupItem colCount={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4} cssClass='fw-profile-form'>
                                <GroupItem colCount={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4} colSpan={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4} cssClass='fw-profile-form-body'>
                                    {FormText({ value: data.user_name, onValueChange: updateField('user_name'), readOnly: !isEditing, label: '성명[한글]', required: true })}
                                    {FormText({ value: data.user_enam, onValueChange: updateField('user_enam'), readOnly: !isEditing, label: '성명[영문]', required: true })}
                                    {FormDate({ value: data.regi_date, onValueChange: updateField('regi_date'), readOnly: !isEditing, label: '입사일', required: true })}
                                    {FormRegx({ value: data.mail_idno, onValueChange: updateField('mail_idno'), readOnly: !isEditing, label: '이메일', rule: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ })}
                                    {FormSelc({ value: data.dept_name, onValueChange: updateField('dept_name'), readOnly: !isEditing, label: '부서', items: deptList, displayExpr: 'dept_name', valueExpr: 'dept_name' })}
                                    {FormSelc({ value: data.posi_name, onValueChange: updateField('posi_name'), readOnly: !isEditing, label: '직급', items: posiList, displayExpr: 'posi_name', valueExpr: 'posi_name' })}
                                    {FormText({ value: data.cell_numb, onValueChange: updateField('cell_numb'), readOnly: !isEditing, label: '휴대폰', mask: '000-0000-0000' })}
                                    {FormText({ value: data.tele_numb, onValueChange: updateField('tele_numb'), readOnly: !isEditing, label: '전화', placeholder: "-포함 입력" })}
                                    {FormText({ value: data.faxs_numb, onValueChange: updateField('faxs_numb'), readOnly: !isEditing, label: '팩스', placeholder: "-포함 입력" })}
                                </GroupItem>
                                <GroupItem colCount={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4} colSpan={isXSmall ? 1 : isSmall ? 2 : isMedium ? 3 : 4} cssClass='fw-profile-form-footer'>
                                    {FormImag({ value: fwUtil.conv.to.buffToBlob(data.sign_imag), onValueChange: updateField('sign_imag'), readOnly: !isEditing, label: '서명이미지', size: 180, allowDrawing: true })}
                                </GroupItem>
                            </GroupItem>
                        </Form>
                        <PanelToolbar
                            isEditing={isEditing}
                            toggleEditHandler={toggleEditHandler}
                            onSaveClick={onSubmit}
                            upd={{ disabled: false }}
                        />
                    </ScrollView>
                </div>
            </div>
            <LoadPanel container='.content' visible={loading} position={{ of: '.layout-body' }} />
        </>
    );
};
